import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {ApiService} from '@aviary/services/api.service';
import {RequestParams} from '@aviary/services/api.service.types';
import {EmailVerificationPayload, EmailVerificationRequest, OPACExistingRegistrationPayload} from '@store/patron/patron.api-types';
import {EmailVerificationStatusView, OPACRegistrationValue} from '@store/registration/registration.types';
import {contextWithErrorHandlerForRequestVerificationEmail, contextWithErrorHandlerForVerifyEmail} from '@store/registration/registration.handlers';

@Injectable({providedIn: 'root'})
export class RegistrationService {

  private readonly apiService: ApiService = inject(ApiService);

  public validatePatronEmailAvailable(email: string): Observable<boolean> {
    const endpoint: string = 'public/v1/patrons/existing-email';
    const params: RequestParams = {email};

    return this.apiService.get(endpoint, {params});
  }

  public requestVerificationEmail(email: string): Observable<string> {
    const endpoint: string = 'public/v1/patrons/request-verification-email';
    const body: EmailVerificationRequest = {email};

    return this.apiService.postAndReturnSingleObject(endpoint, body, {context: contextWithErrorHandlerForRequestVerificationEmail()});
  }

  public checkVerificationStatus(verificationUUID: string): Observable<EmailVerificationStatusView> {
    const endpoint: string = 'public/v1/patrons/verification-status';
    const params: RequestParams = {uuid: verificationUUID};

    return this.apiService.getSingleObject(endpoint, {params});
  }

  public verifyEmail(code: string, verificationUUID: string, navigateOnError: boolean): Observable<EmailVerificationStatusView> {
    const endpoint: string = 'public/v1/patrons/verify-email';
    const body: EmailVerificationPayload = {code, verificationUUID};

    return this.apiService.postAndReturnSingleObject(endpoint, body, {context: contextWithErrorHandlerForVerifyEmail(navigateOnError)});
  }

  public register(value: OPACRegistrationValue): Observable<void> {
    const endpoint: string = 'public/v2/patrons/register';

    return this.apiService.post(endpoint, value);
  }

  public registerExisting(value: OPACRegistrationValue, verificationUUID: string): Observable<void> {
    const endpoint: string = 'public/v1/patrons/register-existing';

    const body: OPACExistingRegistrationPayload = {
      password: value.password,
      branchId: value.branchId,
      verificationUUID
    };

    return this.apiService.post(endpoint, body);
  }
}
